<!--suppress ALL -->
<script lang="ts">
import {statusBayars} from '../../../util/PluralVariabels';
import {Component, Vue, Prop} from 'annotation';
import {cloneArray} from "../../../util/Underscore";

import GField from '../common/field/GField.vue';
import GSelect from '../common/select/GSelect.vue';
import AppConfig from "../../../AppConfig";

@Component
export default class StatusBayarSelect extends Vue {

  @Prop({default: statusBayars[0], type: String})
  public bayar: string;

  @Prop({default: false, type: Boolean})
  public skipLabel: boolean;

  @Prop({default: true, type: Boolean})
  public isFullwidth: boolean;

  @Prop({type: String, default: null})
  public type: any;

  @Prop({type: String, default: null})
  public message: any;

  @Prop({type: Boolean, default: false})
  public disabled: any;


  @Prop({
    default: () => AppConfig.getVm().$t('label.bayar').toString(),
    type: String
  })
  public label: string;

  public onSelectRegistrasi(param: string) {
    this.$emit('update:bayar', param || statusBayars[0].value);
    this.$emit('bayar-selected', param);
  }

  public render(createElement: Function) {
    const {$t, bayar, isFullwidth, label, message, type} = this;

    const mainAttr: any = {
      attrs: {disabled: this.disabled},
      props: {
        value: bayar, isFullwidth,
        placeholder: `${$t('label.choose')} status bayar`
      },
      on: {change: this.onSelectRegistrasi}
    };

    const main: any = createElement(GSelect, mainAttr, cloneArray(statusBayars).map((item: any) => {
      const option: any = {attrs: {value: item.value}};

      return createElement('option', option, item.label);
    }));

    if (this.skipLabel) {
      return main;
    }

    return createElement(GField, {props: {label, message, type}}, [main]);
  }
}
</script>
